import { render, staticRenderFns } from "./IcoBadge.vue?vue&type=template&id=fc2ef368"
import script from "./IcoBadge.vue?vue&type=script&lang=js"
export * from "./IcoBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports